export default "__VITE_ASSET__BXaY5P2F__"